import React from 'react'

import { NotesDirectoryLayoutWrapper } from './Layout'
import { ITEMS_FIRST_PAGE, ITEMS_NEXT_PAGE } from './dataSync'

import ContainerItem from './ContainerItem'

export default function Container({
  id,
  orderField = 'listPosition',
  childrenNotes,
  fetchNextPage,
  listState,
}) {
  const [itemCount, setItemCount] = React.useState(ITEMS_FIRST_PAGE)

  React.useEffect(
    function onMount() {
      setItemCount(ITEMS_FIRST_PAGE)
      fetchNextPage({ startFresh: true })
    },
    [id, fetchNextPage]
  )

  const onClickMore = React.useCallback(
    () => {
      fetchNextPage()
      setItemCount(itemCount + ITEMS_NEXT_PAGE)
    },
    [fetchNextPage, itemCount]
  )

  const itemData = React.useMemo(() => childrenNotes.slice(0, itemCount), [
    childrenNotes,
    itemCount,
  ])

  if (childrenNotes.length === 0) {
    return null
  }

  const isLoading = listState.loading
  const hasMore = !isLoading && listState.pageInfo.hasNextPage
  const hasTwoColumns =
    orderField === 'listPosition' && childrenNotes.length > 4

  return (
    <NotesDirectoryLayoutWrapper
      title={orderField === 'lastActivityAt' ? 'Recently updated' : 'Directory'}
      hasTwoColumns={hasTwoColumns}
      hasMore={hasMore}
      onClickMore={onClickMore}
      itemData={itemData}
      ItemComponent={ContainerItem}
    />
  )
}
